module.exports = __webpack_public_path__ + "static/media/dochilove_spinoff.3adc797a.png";